const COMPARE_EXCLUDED_SPEC_LABELS = new Set(["price", "moq", "lead time", "shipping terms"]);

export const MAX_COMPARE_PRODUCTS = 3;

export function getCompareMoqLabel(item) {
  if (item?.moq != null && String(item.moq).trim()) {
    const unit = item.moq_unit?.trim() || "units";
    return `${item.moq} ${unit}`.trim();
  }
  const moqSpec = item?.spec_items?.find((spec) => spec.label?.toLowerCase() === "moq");
  if (moqSpec?.value) return moqSpec.value;
  if (item?.moq_label) return item.moq_label.replace(/^MOQ:\s*/i, "");
  return "—";
}

export function getCompareDeliveryLabel(item) {
  if (item?.lead_time_label) return item.lead_time_label;
  const leadSpec = item?.spec_items?.find((spec) => spec.label?.toLowerCase() === "lead time");
  return leadSpec?.value || "—";
}

export function getCompareSpecItems(item) {
  return (Array.isArray(item?.spec_items) ? item.spec_items : []).filter(
    (spec) => !COMPARE_EXCLUDED_SPEC_LABELS.has(String(spec.label || "").toLowerCase()),
  );
}

export function parseCompareRatingValue(item) {
  const raw = item?.rating_label;
  if (raw == null || raw === "") return null;
  const match = String(raw).match(/([\d.]+)/);
  if (!match) return null;
  const value = Number(match[1]);
  return Number.isFinite(value) ? value : null;
}

export function getCompareExportCustom(item) {
  const haystack = [
    ...(Array.isArray(item?.spec_items) ? item.spec_items : []).map((spec) => `${spec.label} ${spec.value}`),
    ...(Array.isArray(item?.cert_badges) ? item.cert_badges : []),
    item?.shipping_terms_label,
    item?.company_name,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  const exportReady =
    haystack.includes("export") ||
    haystack.includes("iec") ||
    (Array.isArray(item?.cert_badges) && item.cert_badges.length > 0);

  const customMfg =
    haystack.includes("custom") ||
    haystack.includes("oem") ||
    haystack.includes("odm");

  return { exportReady, customMfg };
}
